import { availabilityTypeConstant } from 'us-react-components/dist/constants/Booking';
import { ScheduleTypes } from 'us-web-services';

const PART_TIME_AVAILABILITY_ID = availabilityTypeConstant.find((a: { id?: number; }) => a.id === 1)?.id;
const FULL_TIME_AVAILABILITY_ID = availabilityTypeConstant.find((a: { id?: number; }) => a.id === 2)?.id;
const OCCASIONAL_AVAILABILITY_ID = availabilityTypeConstant.find((a: { id?: number; }) => a.id === 3)?.id;

const PART_TIME_SCHEDULE_TYPE_ID = ScheduleTypes.find((st: { id?: number | null; }) => st.id === 19)?.id;
const FULL_TIME_SCHEDULE_TYPE_ID = ScheduleTypes.find((st: { id?: number | null; }) => st.id === 18)?.id;
const DROP_IN_SCHEDULE_TYPE_ID = ScheduleTypes.find((st: { id?: number | null; }) => st.id === 12)?.id;

export const getScheduleTypeFromAvailability  = (availabilityId: number | undefined): number | null | undefined => {
  switch (availabilityId) {
    case PART_TIME_AVAILABILITY_ID:
      return PART_TIME_SCHEDULE_TYPE_ID;
    case FULL_TIME_AVAILABILITY_ID:
      return FULL_TIME_SCHEDULE_TYPE_ID;
    case OCCASIONAL_AVAILABILITY_ID:
      return DROP_IN_SCHEDULE_TYPE_ID;
    default:
      return undefined;
  }
};
